// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.data-row {
  background: #0f172a; /* dark blue */
  color: #ffffff;
  padding: 16px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.row-header {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  font-weight: 600;
}

.title {
  text-transform: uppercase;
}

.live-badge {
  background: #22c55e;
  color: #ffffff;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
}

.row-time {
  margin-top: 6px;
  font-size: 13px;
  color: #cbd5f5;
}

.metrics {
  display: flex;
  gap: 16px;
  margin-top: 14px;
}

.metric-box {
  background: #020617;
  padding: 12px 16px;
  border-radius: 8px;
  min-width: 120px;
}

.labelULB {
   background: #7d15c2;
   color: white;
  padding: 10px 10px;
  border-radius: 8px;
   min-width: 80px;
}

.labeBack {
   background: #bca5cb;
   color: rgb(23, 3, 31);
  font-size: 15px;
  font-weight: 700;
}
.metric-label {
  display: block;
  font-size: 12px;
  color: #94a3b8;
}

.metric-value {
  font-size: 22px;
  font-weight: 700;
}
.toggle-container {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.toggle-container input {
  display: none;
}

.toggle-switch {
  width: 46px;
  height: 24px;
  background: #334155;
  border-radius: 999px;
  position: relative;
  transition: background 0.3s;
}

.toggle-switch::after {
  content: "";
  width: 18px;
  height: 18px;
  background: #ffffff;
  border-radius: 50%;
  position: absolute;
  top: 3px;
  left: 3px;
  transition: transform 0.3s;
}

.toggle-container input:checked + .toggle-switch {
  background: #22c55e;
}

.toggle-container input:checked + .toggle-switch::after {
  transform: translateX(22px);
}

.toggle-label {
  font-weight: 600;
  font-size: 16px;
  color: #020617;
}


/* // code for header TABLE LIST  */
.district-table {
  margin-top: 2%;
  width: 100%;
  background: #000000;
  color: #ffffff;
  font-family: "Segoe UI", sans-serif;
  height: 350px;          /* fixed height */
  overflow-y: auto;       /* vertical scroll if content exceeds height */
  overflow-x: hidden;     /* prevent horizontal scroll, optional */
  padding: 0.5rem;        /* optional, for spacing */
  border-radius: 5px;     /* optional, for nicer look */
}

.table-row {
  display: grid;
  grid-template-columns: 60px 1.5fr 1fr 80px;
  padding: 10px 12px;
  align-items: center;
  border-bottom: 1px solid #1f2937;
  font-size: 14px;
  transition: background 0.25s ease, transform 0.15s ease;
}
.table-row.active {
  background-color: #93dee4;
  color: #000;
  box-shadow: inset 0 0 10px #1f312f;
}
.table-row:hover {
  font-weight: 700;
  border-bottom: 2px solid #90a8ce;
   background-color: #7e8b93;
   color: #000000;
}

.district {
  text-transform: uppercase;
}

.status {
  text-align: center;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
}

.status.live {
  background: #22c55e;
  color: #ffffff;
}

.status.offline {
  background: #6b7280;
  color: #ffffff;
}



/* // SCADA code for dashboard */
/* dashboard.css */
:root {
  --bg: #050816;
  --bg-alt: #0b1020;
  --card-bg: #141827;
  --border: #2f3a56;
  --accent: #00d47f;
  --text: #ffffff;
  --muted: #9ca3af;
}



.page {
  
background: #5ac93e;
background: radial-gradient(circle,rgb(7, 175, 100) 0%, rgba(18, 138, 128, 0.97) 58%, rgb(25, 220, 207) 89%);
  display: grid;
  grid-template-columns: 2.2fr 1.1fr;
  grid-template-rows: auto auto;
  grid-template-areas:
    "left right"
    "bottom bottom";
  gap: 16px;
  padding: 16px;
  box-sizing: border-box;
}

/* LEFT COLUMN */
.left-column {
  grid-area: left;
  display: flex;
  flex-direction: column;
  gap: 16px;
  
}

/* .block {
  background: var(--bg-alt);
  border-radius: 8px;
  padding: 12px 12px 16px;
  box-shadow: 0 0 0 1px #111827;
} */

/* //HEADER PART */
.status-bar {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px 16px;
  background-color: #1e293b; /* Dark slate blue-gray */
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  color: #f1f5f9; /* Light text */
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.status-bar > div:first-child {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.status-title {
  font-weight: 700;
  font-size: 1.1rem;
  letter-spacing: 0.05em;
  color: #e0e7ff; /* Light indigo */
  text-transform: uppercase;
}

.status-live {
  background: #22c55e; /* Bright green */
  color: white;
  font-weight: 600;
  font-size: 12px;
  padding: 3px 12px;
  border-radius: 9999px; /* Pill shape */
  box-shadow: 0 0 6px #22c55eaa;
  -webkit-user-select: none;
          user-select: none;
  transition: background-color 0.3s ease;
}

.status-live.offline {
  background: #f2eeee; /* Bright red */
  box-shadow: 0 0 6px #e0d8d8aa;
}

.status-time {
  font-size:20px;
  color: #94a3b8; /* Muted light blue-gray */
  font-style: italic;
}


.row-container {
  display: flex;
  align-items: center;
  gap: 15px;   
     /* space between both divs */
}

.badgeDate {
  background: #1f2a36;
  color: #fff;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 14px;
}

.status-badge {
  background: #1ded88;
  color: #040c32;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 14px;
}

/* // HEADEER PART */

.cards-grid {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 20px;  
}

.card {
  background: var(--card-bg);
  border-radius: 8px;
  padding: 10px 12px;
  border: 1px solid white;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  
}

.card-header {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  color: var(--muted);
}

.card-title {
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.card-value {
  padding-top: -10px;
 text-align: center;
  font-size: 25px;
}

.card-unit {
  font-size: 12px;
  color: var(--muted);
}

.card-footer {
  
  font-size: 10px;
  color:#ecf1ef;
  display: flex;
  justify-content: space-between;
}

.card-no-data {
  font-size: 14px;
  color: var(--muted);
}

/* RIGHT COLUMN */
.right-column {
  grid-area: right;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.info-header {
  background: var(--bg-alt);
  border-radius: 8px;
  padding: 12px;
  border: 1px solid var(--border);
}

.info-title {
  color:white;
  font-weight: 600;
  line-height: 1.3;
  margin-bottom: 8px;
}

.info-address .label,
.info-footer .label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--muted);
  margin-top: 6px;
}

.map-card {
  background: var(--bg-alt);
  border-radius: 8px;
  padding: 10px;
  border: 1px solid var(--border);
}

.map-placeholder {
  height: 260px;
  border-radius: 6px;
  background: radial-gradient(circle at top, #1f2937, #020617);
  border: 1px solid #1f2937;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--muted);
  font-size: 12px;
}

.info-footer {
  background: var(--bg-alt);
  border-radius: 8px;
  padding: 12px;
  border: 1px solid var(--border);
  display: flex;
  justify-content: space-between;
  font-size: 12px;
}

/* BOTTOM SECTION */
.bottom-section {
  grid-area: bottom;
  background: var(--bg-alt);
  border-radius: 8px;
  padding: 12px;
  border: 1px solid var(--border);
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.bottom-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: flex-end;
}

.filter {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 11px;
  color: var(--muted);
}

.filter select,
.filter input {
  background: var(--card-bg);
  border-radius: 4px;
  border: 1px solid var(--border);
  color: var(--text);
  padding: 4px 8px;
  font-size: 12px;
}

.btn-primary {
  background: var(--accent);
  border: none;
  border-radius: 4px;
  padding: 6px 16px;
  font-size: 12px;
  font-weight: 600;
  color: #022c22;
  cursor: pointer;
}

.chart-card {
  background: var(--card-bg);
  border-radius: 8px;
  padding: 10px;
  border: 1px solid var(--border);
}

.chart-header {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--muted);
  margin-bottom: 8px;
}

.chart-placeholder {
  height: 180px;
  border-radius: 6px;
  background: linear-gradient(to bottom, #020617, #020617);
  border: 1px solid #1f2937;
  color: var(--muted);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}

/* Responsive */
@media (max-width: 1024px) {
  .page {
    grid-template-columns: 1fr;
    grid-template-areas:
      "left"
      "right"
      "bottom";
  }
}

/* 
// animination  */
.card-value {
    padding-top: -20px;
  color: white;
  font-size: 22px;
  font-weight: 600;
  text-align: center;
  animation: showHide 2s infinite ease-in-out;
}

@keyframes showHide {
  0% {
    opacity: 1;
    transform: translateY(0);
  }

  40% {
    opacity: 1;
    transform: translateY(0);
  }

  60% {
    opacity: 0;
    transform: translateY(10px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/GisTools/ScadaCSS.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB,EAAE,cAAc;EACnC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;GACG,mBAAmB;GACnB,YAAY;EACb,kBAAkB;EAClB,kBAAkB;GACjB,eAAe;AAClB;;AAEA;GACG,mBAAmB;GACnB,qBAAqB;EACtB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;;AAGA,mCAAmC;AACnC;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,mCAAmC;EACnC,aAAa,WAAW,iBAAiB;EACzC,gBAAgB,QAAQ,8CAA8C;EACtE,kBAAkB,MAAM,wCAAwC;EAChE,eAAe,SAAS,0BAA0B;EAClD,kBAAkB,MAAM,6BAA6B;AACvD;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,uDAAuD;AACzD;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,kCAAkC;AACpC;AACA;EACE,gBAAgB;EAChB,gCAAgC;GAC/B,yBAAyB;GACzB,cAAc;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;;;AAIA,gCAAgC;AAChC,kBAAkB;AAClB;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;;;AAIA;;AAEA,mBAAmB;AACnB,4GAA4G;EAC1G,aAAa;EACb,kCAAkC;EAClC,6BAA6B;EAC7B;;mBAEiB;EACjB,SAAS;EACT,aAAa;EACb,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;;AAEX;;AAEA;;;;;GAKG;;AAEH,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB,EAAE,yBAAyB;EACpD,kBAAkB;EAClB,wCAAwC;EACxC,cAAc,EAAE,eAAe;EAC/B,4DAA4D;AAC9D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc,EAAE,iBAAiB;EACjC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB,EAAE,iBAAiB;EACtC,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qBAAqB,EAAE,eAAe;EACtC,6BAA6B;EAC7B,yBAAiB;UAAjB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB,EAAE,eAAe;EACpC,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,cAAc,EAAE,0BAA0B;EAC1C,kBAAkB;AACpB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;KACN,4BAA4B;AACjC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,oBAAoB;;AAEpB;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;;AAEhC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;CACnB,kBAAkB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,aAAa;EACb,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,4DAA4D;EAC5D,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,0BAA0B;EAC1B,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,wDAAwD;EACxD,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;IAC1B;;;cAGU;EACZ;AACF;;AAEA;iBACiB;AACjB;IACI,kBAAkB;EACpB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;;EAEA;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[".table-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.data-row {\n  background: #0f172a; /* dark blue */\n  color: #ffffff;\n  padding: 16px;\n  border-radius: 10px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n}\n\n.row-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.title {\n  text-transform: uppercase;\n}\n\n.live-badge {\n  background: #22c55e;\n  color: #ffffff;\n  padding: 4px 10px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.row-time {\n  margin-top: 6px;\n  font-size: 13px;\n  color: #cbd5f5;\n}\n\n.metrics {\n  display: flex;\n  gap: 16px;\n  margin-top: 14px;\n}\n\n.metric-box {\n  background: #020617;\n  padding: 12px 16px;\n  border-radius: 8px;\n  min-width: 120px;\n}\n\n.labelULB {\n   background: #7d15c2;\n   color: white;\n  padding: 10px 10px;\n  border-radius: 8px;\n   min-width: 80px;\n}\n\n.labeBack {\n   background: #bca5cb;\n   color: rgb(23, 3, 31);\n  font-size: 15px;\n  font-weight: 700;\n}\n.metric-label {\n  display: block;\n  font-size: 12px;\n  color: #94a3b8;\n}\n\n.metric-value {\n  font-size: 22px;\n  font-weight: 700;\n}\n.toggle-container {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n}\n\n.toggle-container input {\n  display: none;\n}\n\n.toggle-switch {\n  width: 46px;\n  height: 24px;\n  background: #334155;\n  border-radius: 999px;\n  position: relative;\n  transition: background 0.3s;\n}\n\n.toggle-switch::after {\n  content: \"\";\n  width: 18px;\n  height: 18px;\n  background: #ffffff;\n  border-radius: 50%;\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  transition: transform 0.3s;\n}\n\n.toggle-container input:checked + .toggle-switch {\n  background: #22c55e;\n}\n\n.toggle-container input:checked + .toggle-switch::after {\n  transform: translateX(22px);\n}\n\n.toggle-label {\n  font-weight: 600;\n  font-size: 16px;\n  color: #020617;\n}\n\n\n/* // code for header TABLE LIST  */\n.district-table {\n  margin-top: 2%;\n  width: 100%;\n  background: #000000;\n  color: #ffffff;\n  font-family: \"Segoe UI\", sans-serif;\n  height: 350px;          /* fixed height */\n  overflow-y: auto;       /* vertical scroll if content exceeds height */\n  overflow-x: hidden;     /* prevent horizontal scroll, optional */\n  padding: 0.5rem;        /* optional, for spacing */\n  border-radius: 5px;     /* optional, for nicer look */\n}\n\n.table-row {\n  display: grid;\n  grid-template-columns: 60px 1.5fr 1fr 80px;\n  padding: 10px 12px;\n  align-items: center;\n  border-bottom: 1px solid #1f2937;\n  font-size: 14px;\n  transition: background 0.25s ease, transform 0.15s ease;\n}\n.table-row.active {\n  background-color: #93dee4;\n  color: #000;\n  box-shadow: inset 0 0 10px #1f312f;\n}\n.table-row:hover {\n  font-weight: 700;\n  border-bottom: 2px solid #90a8ce;\n   background-color: #7e8b93;\n   color: #000000;\n}\n\n.district {\n  text-transform: uppercase;\n}\n\n.status {\n  text-align: center;\n  padding: 4px 10px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.status.live {\n  background: #22c55e;\n  color: #ffffff;\n}\n\n.status.offline {\n  background: #6b7280;\n  color: #ffffff;\n}\n\n\n\n/* // SCADA code for dashboard */\n/* dashboard.css */\n:root {\n  --bg: #050816;\n  --bg-alt: #0b1020;\n  --card-bg: #141827;\n  --border: #2f3a56;\n  --accent: #00d47f;\n  --text: #ffffff;\n  --muted: #9ca3af;\n}\n\n\n\n.page {\n  \nbackground: #5ac93e;\nbackground: radial-gradient(circle,rgb(7, 175, 100) 0%, rgba(18, 138, 128, 0.97) 58%, rgb(25, 220, 207) 89%);\n  display: grid;\n  grid-template-columns: 2.2fr 1.1fr;\n  grid-template-rows: auto auto;\n  grid-template-areas:\n    \"left right\"\n    \"bottom bottom\";\n  gap: 16px;\n  padding: 16px;\n  box-sizing: border-box;\n}\n\n/* LEFT COLUMN */\n.left-column {\n  grid-area: left;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  \n}\n\n/* .block {\n  background: var(--bg-alt);\n  border-radius: 8px;\n  padding: 12px 12px 16px;\n  box-shadow: 0 0 0 1px #111827;\n} */\n\n/* //HEADER PART */\n.status-bar {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 12px 16px;\n  background-color: #1e293b; /* Dark slate blue-gray */\n  border-radius: 8px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);\n  color: #f1f5f9; /* Light text */\n  font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.status-bar > div:first-child {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.status-title {\n  font-weight: 700;\n  font-size: 1.1rem;\n  letter-spacing: 0.05em;\n  color: #e0e7ff; /* Light indigo */\n  text-transform: uppercase;\n}\n\n.status-live {\n  background: #22c55e; /* Bright green */\n  color: white;\n  font-weight: 600;\n  font-size: 12px;\n  padding: 3px 12px;\n  border-radius: 9999px; /* Pill shape */\n  box-shadow: 0 0 6px #22c55eaa;\n  user-select: none;\n  transition: background-color 0.3s ease;\n}\n\n.status-live.offline {\n  background: #f2eeee; /* Bright red */\n  box-shadow: 0 0 6px #e0d8d8aa;\n}\n\n.status-time {\n  font-size:20px;\n  color: #94a3b8; /* Muted light blue-gray */\n  font-style: italic;\n}\n\n\n.row-container {\n  display: flex;\n  align-items: center;\n  gap: 15px;   \n     /* space between both divs */\n}\n\n.badgeDate {\n  background: #1f2a36;\n  color: #fff;\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-size: 14px;\n}\n\n.status-badge {\n  background: #1ded88;\n  color: #040c32;\n  padding: 6px 12px;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n/* // HEADEER PART */\n\n.cards-grid {\n  display: grid;\n  grid-template-columns: repeat(6, minmax(0, 1fr));\n  gap: 20px;  \n}\n\n.card {\n  background: var(--card-bg);\n  border-radius: 8px;\n  padding: 10px 12px;\n  border: 1px solid white;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  \n}\n\n.card-header {\n  display: flex;\n  justify-content: space-between;\n  font-size: 16px;\n  color: var(--muted);\n}\n\n.card-title {\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n.card-value {\n  padding-top: -10px;\n text-align: center;\n  font-size: 25px;\n}\n\n.card-unit {\n  font-size: 12px;\n  color: var(--muted);\n}\n\n.card-footer {\n  \n  font-size: 10px;\n  color:#ecf1ef;\n  display: flex;\n  justify-content: space-between;\n}\n\n.card-no-data {\n  font-size: 14px;\n  color: var(--muted);\n}\n\n/* RIGHT COLUMN */\n.right-column {\n  grid-area: right;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.info-header {\n  background: var(--bg-alt);\n  border-radius: 8px;\n  padding: 12px;\n  border: 1px solid var(--border);\n}\n\n.info-title {\n  color:white;\n  font-weight: 600;\n  line-height: 1.3;\n  margin-bottom: 8px;\n}\n\n.info-address .label,\n.info-footer .label {\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--muted);\n  margin-top: 6px;\n}\n\n.map-card {\n  background: var(--bg-alt);\n  border-radius: 8px;\n  padding: 10px;\n  border: 1px solid var(--border);\n}\n\n.map-placeholder {\n  height: 260px;\n  border-radius: 6px;\n  background: radial-gradient(circle at top, #1f2937, #020617);\n  border: 1px solid #1f2937;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--muted);\n  font-size: 12px;\n}\n\n.info-footer {\n  background: var(--bg-alt);\n  border-radius: 8px;\n  padding: 12px;\n  border: 1px solid var(--border);\n  display: flex;\n  justify-content: space-between;\n  font-size: 12px;\n}\n\n/* BOTTOM SECTION */\n.bottom-section {\n  grid-area: bottom;\n  background: var(--bg-alt);\n  border-radius: 8px;\n  padding: 12px;\n  border: 1px solid var(--border);\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.bottom-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  align-items: flex-end;\n}\n\n.filter {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 11px;\n  color: var(--muted);\n}\n\n.filter select,\n.filter input {\n  background: var(--card-bg);\n  border-radius: 4px;\n  border: 1px solid var(--border);\n  color: var(--text);\n  padding: 4px 8px;\n  font-size: 12px;\n}\n\n.btn-primary {\n  background: var(--accent);\n  border: none;\n  border-radius: 4px;\n  padding: 6px 16px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #022c22;\n  cursor: pointer;\n}\n\n.chart-card {\n  background: var(--card-bg);\n  border-radius: 8px;\n  padding: 10px;\n  border: 1px solid var(--border);\n}\n\n.chart-header {\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: var(--muted);\n  margin-bottom: 8px;\n}\n\n.chart-placeholder {\n  height: 180px;\n  border-radius: 6px;\n  background: linear-gradient(to bottom, #020617, #020617);\n  border: 1px solid #1f2937;\n  color: var(--muted);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n  .page {\n    grid-template-columns: 1fr;\n    grid-template-areas:\n      \"left\"\n      \"right\"\n      \"bottom\";\n  }\n}\n\n/* \n// animination  */\n.card-value {\n    padding-top: -20px;\n  color: white;\n  font-size: 22px;\n  font-weight: 600;\n  text-align: center;\n  animation: showHide 2s infinite ease-in-out;\n}\n\n@keyframes showHide {\n  0% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n\n  40% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n\n  60% {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
